import {isDev} from "@/constants.js";
import Bugsnag from '@bugsnag/js'
class Logger {
    static error(...err) {
        console.error(...err)
        Bugsnag.notify(err)
    }

    static log(...data) {
        isDev && console.log(...data)
    }
}

export default Logger